import { useState, useEffect, useCallback } from "react";
import {
  getIndiaStates,
  getCitiesByStateCode,
  resolveStateCode,
} from "./indiaStateCity";

export function useIndiaStateCity(initialSelectedState = "") {
  const [states, setStates] = useState(() => getIndiaStates());
  const [cities, setCities] = useState([]);
  const [selectedState, setSelectedState] = useState(initialSelectedState);

  const loadStatesList = useCallback(async () => {
    const list = getIndiaStates();
    setStates(list);
    return list;
  }, []);

  useEffect(() => {
    if (!selectedState) {
      setCities([]);
      return;
    }

    let cancelled = false;
    const loadCities = async () => {
      const stateCode = resolveStateCode(selectedState, states);
      if (!stateCode) {
        if (!cancelled) setCities([]);
        return;
      }

      const nextCities = await getCitiesByStateCode(stateCode);
      if (!cancelled) setCities(nextCities);
    };

    loadCities();
    return () => {
      cancelled = true;
    };
  }, [selectedState, states]);

  return {
    states,
    cities,
    selectedState,
    setSelectedState,
    loadStatesList,
    resolveStateCode: (value) => resolveStateCode(value, states),
  };
}
